import dayjs from "dayjs";
import { CurrencyFormatter } from "../../../components/Helpers";
import styles from "../reports.module.css";
import useServerReport from "../components/useServerReport";
import ReportTable from "../components/ReportTable";
import { toNumber } from "../components/exportUtils";

const formatDate = (value) => (value ? dayjs(value).format("DD/MM/YYYY") : "-");

const columns = [
    { key: "booking_id", label: "Booking Id", primary: true },
    { key: "customer_name", label: "Customer Name" },
    { key: "created_at", label: "Order Date", render: (row) => formatDate(row?.created_at) },
    { key: "total", label: "Total Amount", align: "right", render: (row) => CurrencyFormatter(toNumber(row?.total)) },
    { key: "paid_amount", label: "Paid Amount", align: "right", render: (row) => CurrencyFormatter(toNumber(row?.paid_amount)) },
    { key: "due_balance", label: "Due Balance", align: "right", render: (row) => CurrencyFormatter(toNumber(row?.due_balance)) },
    {
        key: "payment_status", label: "Payment Status", render: (row) => (parseInt(row?.payment_status) === 1
            ? <span className={`${styles.StatusPill} ${styles.StatusPaid}`}>Paid</span>
            : <span className={`${styles.StatusPill} ${styles.StatusUnpaid}`}>Unpaid</span>)
    },
    { key: "post_code", label: "Pickup Post Code" },
    { key: "pickup_date", label: "Pickup Date", render: (row) => formatDate(row?.pickup_date) },
    { key: "created_user", label: "Created User" },
];

const ContainerReportDetails = ({ containerId }) => {
    const report = useServerReport("report/container-report/" + containerId);

    return (<ReportTable report={report} columns={columns} minWidth={1100} emptyText="No bookings in this container" />);
};

export default ContainerReportDetails;
